module.exports = __webpack_public_path__ + "static/stock-image-1-f221cd7ac49edd78c186998f8735816f.jpg";